import { render, staticRenderFns } from "./ResourceFormDialog.vue?vue&type=template&id=ed1423da&scoped=true&"
import script from "./ResourceFormDialog.vue?vue&type=script&lang=js&"
export * from "./ResourceFormDialog.vue?vue&type=script&lang=js&"
import style0 from "./ResourceFormDialog.vue?vue&type=style&index=0&id=ed1423da&prod&lang=scss&"
import style1 from "./ResourceFormDialog.vue?vue&type=style&index=1&id=ed1423da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1423da",
  null
  
)

export default component.exports